import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

// TODO(HSA-37): temporary, for testing the classifier from scratch on the
// pilot. Remove before launch.

/** Deletes every HSA classification decision of the team so the classifier can run from scratch. */
export const resetHsaClassifications = {
  name: "resetHsaClassifications" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ deleted: z.number(), ledgerRows: z.number() }),
};
